import { mapApprover } from '@webapp/core/data-access/mappers/mapApprover'
import { mapCurrency } from '@webapp/core/data-access/mappers/mapCurrency'
import { mapDepartment } from '@webapp/core/data-access/mappers/mapDepartment'
import { mapLocation } from '@webapp/core/data-access/mappers/mapLocation'
import { mapRequester } from '@webapp/core/data-access/mappers/mapRequester'
import { ExpensePaymentTypes } from '../../entities/enums/ExpensePaymentTypeEnum'
import { ExpenseTypes } from '../../entities/enums/ExpenseTypeEnum'
import { type ExpenseSummaryConstructor } from '../../entities/ExpenseSummary'
import { type ExpenseSummaryApiModel } from '../api-models/ExpenseSummaryApiModel'

export const mapExpenseSummaryApiModel = (
  expenseSummary: ExpenseSummaryApiModel
): ExpenseSummaryConstructor => ({
  id: expenseSummary.id,
  uuid: expenseSummary.uuid,
  reimbursableAmount: expenseSummary.reimbursable_amount,
  status: expenseSummary.status,
  submittedDate: expenseSummary.createdDate,
  currency: mapCurrency(expenseSummary.currency),
  title: expenseSummary.title,
  primaryCategory: mapLocation(expenseSummary.branch),
  secondaryCategory: mapDepartment(expenseSummary.department),
  requester: mapRequester(expenseSummary.user),
  nextApprover: expenseSummary.next_approver
    ? mapApprover(expenseSummary.next_approver)
    : null,
  items: expenseSummary.items.map((item) => ({
    id: item.id,
    account: {
      id: item.account.id,
      accountCode: {
        id: item.account.account_code.id,
        description: item.account.account_code.description,
        code: item.account.account_code.code,
        active: item.account.account_code.active,
        type: item.account.account_code.account_type,
      },
      active: item.active,
      secondaryCategory: mapDepartment(item.account.department),
    },
    attachment: item.attachment || null,
    paymentCard: item.creditcard
      ? {
          id: item.creditcard.id,
          name: item.creditcard.name,
          last4Digits: item.creditcard.number,
          vendor: item.creditcard.type,
        }
      : null,
    merchant: item.merchant,
    reimbursable: item.reimburse,
    transactionDate: item.transDate,
    taxAmount: parseFloat(item.tax_amount),
    taxPercentage: item.tax_percentage,
    taxName: item.tax_name,
    taxId: item.tax_id,
    amount: parseFloat(item.amount),
    notes: '',
    currency: mapCurrency(item.localCurrency),
    expenseType: ExpenseTypes.OTHER,
    paymentType: ExpensePaymentTypes.CASH,
    expenseTypeData: { type: 'OTHER' as const, data: null },
  })),
  logs: expenseSummary.logs.map((log) => ({
    id: log.id,
    action: log.action,
    dateTime: log.dateTime,
    user: mapApprover(log.user),
  })),
  totalAmount: expenseSummary.total_amount,
})
